import React from 'react';

export const HeapManagementGuide = () => {
  return (
    <div className="guide-page map-3d-sidebar-content">
      <ul>
        <li>
          <span> Step 1 - </span> <p>Go to the Draw tab </p>
        </li>
        <li>
          <span> Step 2 - </span> <p>Draw Polygons along desired heaps</p>
        </li>
        <li>
          <span> Step 3 - </span> <p>Fill in the required details</p>
        </li>
        <li>
          <span> Step 4 - </span> <p> Press {`"Calculate"`} to confirm </p>
        </li>
        <li>
          <span> Step 5 - </span>
          <p>
            Wait for the platform to save and process your request. Your
            processed request will always be available in the "List" tab when
            you log in.
          </p>
        </li>
      </ul>
    </div>
  );
};
